import React from 'react';

import { Disabler } from '@/components/molecules/Disabler';
import { ValidationSchema } from '@/types/fields';

interface Props<T> {
  readonly name?: string;
  readonly validationSchema: ValidationSchema<T>;
  readonly loading?: boolean;

  onChange?(event: React.FormEvent): void;
}

export function Form<T>(props: React.PropsWithChildren<Props<T>>): React.ReactElement {
  const { name, children, loading = false } = props;

  const suppressReturnSubmission = React.useCallback(
    (event: React.KeyboardEvent<HTMLFormElement>): void => {
      if (event.key === 'Enter' || event.key === 'Return') {
        event.preventDefault();
      }
    },
    [],
  );

  return (
    <>
      <form id={name} aria-label={name} name={name} onKeyDown={suppressReturnSubmission}>
        {children}
      </form>

      <Disabler disabled={loading} />
    </>
  );
}
